export default __webpack_public_path__ + "da107c74b119bf13f510d6efa770d351.svg";